"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMonthSpent = exports.aggregateMonthlyTransactions = exports.calculateTotalAnnualSpend = void 0;
var get_1 = __importDefault(require("lodash/get"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var calculateTotalAnnualSpend = function (sStats) { var _a; return (_a = (0, sumBy_1.default)(sStats, 'calculatedAnnualSpend')) !== null && _a !== void 0 ? _a : 0; };
exports.calculateTotalAnnualSpend = calculateTotalAnnualSpend;
var aggregateMonthlyTransactions = function (txns) { return (0, sumBy_1.default)(txns, 'amount'); };
exports.aggregateMonthlyTransactions = aggregateMonthlyTransactions;
var calculateMonthSpent = function (serviceStatWithService, monthDate) {
    var _a;
    return (_a = (0, sumBy_1.default)(serviceStatWithService, function (sStat) { var _a; return (_a = (0, exports.aggregateMonthlyTransactions)((0, get_1.default)(sStat, "expenditures[".concat(monthDate.getFullYear(), "][").concat(monthDate.getMonth() + 1, "]")))) !== null && _a !== void 0 ? _a : 0; })) !== null && _a !== void 0 ? _a : 0;
};
exports.calculateMonthSpent = calculateMonthSpent;
